import Counter from "./Counter.vue";
import { pluginify } from "./../../util";
export default pluginify(Counter);
export { Counter };
